 /* ================= OY DELIVERY PROMISE BADGES START ================= */
(function () {
  "use strict";

  var TAG_CACHE_KEY = "oy_delivery_tag_cache_v8";
  var TAG_CACHE_TTL = 30 * 60 * 1000;
  var TAG_CACHE = loadTagCache();
  var FETCH_PROMISES = Object.create(null);
  var observerTimer = null;
  var minuteTimer = null;

  function injectCSSOnce() {
    if (document.getElementById("oy-delivery-promise-badge-css")) return;

    var style = document.createElement("style");
    style.id = "oy-delivery-promise-badge-css";

    style.textContent =
      ".oy-delivery-badge-wrap{" +
        "display:flex;" +
        "align-items:center;" +
        "width:100%;" +
        "margin:6px 0 7px;" +
        "line-height:1.2;" +
        "font-family:inherit;" +
      "}" +

      ".oy-delivery-badge{" +
        "display:inline-flex;" +
        "align-items:center;" +
        "gap:6px;" +
        "max-width:100%;" +
        "padding:6px 8px;" +
        "background:#fff1f6;" +
        "border:1px solid #ffd2df;" +
        "border-radius:8px;" +
        "color:#222;" +
        "font-family:inherit;" +
        "font-size:12px;" +
        "font-weight:500;" +
        "line-height:1.25;" +
        "white-space:nowrap;" +
        "box-sizing:border-box;" +
      "}" +

      ".oy-delivery-badge *{" +
        "box-sizing:border-box;" +
      "}" +

       

      ".oy-delivery-badge-prefix{" +
        "color:#222;" +
        "font-weight:500;" +
      "}" +

      ".oy-delivery-badge-time{" +
        "color:#e91e63;" +
        "font-weight:700;" +
      "}" +

      "@media(max-width:749px){" +
        ".oy-delivery-badge-wrap{margin:5px 0 6px;}" +
        ".oy-delivery-badge{font-size:12px;padding:6px 7px;border-radius:7px;gap:5px;}" +       
      "}";

    document.head.appendChild(style);
  }

  function loadTagCache() {
    try {
      var raw = sessionStorage.getItem(TAG_CACHE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function saveTagCache() {
    try {
      sessionStorage.setItem(TAG_CACHE_KEY, JSON.stringify(TAG_CACHE));
    } catch (e) {}
  }

  function getCachedTags(handle) {
    var entry = TAG_CACHE[handle];

    if (!entry) return null;
    if (!entry.tags || !entry.ts) return null;

    if (Date.now() - entry.ts > TAG_CACHE_TTL) {
      delete TAG_CACHE[handle];
      saveTagCache();
      return null;
    }

    return entry.tags;
  }

  function setCachedTags(handle, tags) {
    TAG_CACHE[handle] = {
      tags: tags,
      ts: Date.now()
    };

    saveTagCache();
  }

  function normalizeTags(tags) {
    var list = [];

    if (Array.isArray(tags)) {
      list = tags;
    } else if (typeof tags === "string") {
      list = tags.split(",");
    } else if (tags) {
      list = [String(tags)];
    }

    return list.map(function (tag) {
      return String(tag || "").trim().toLowerCase();
    });
  }

  /* Express priority if both tags exist */
  function getDeliveryType(tags) {
    var cleanTags = normalizeTags(tags);

    if (cleanTags.indexOf("express") !== -1) return "express";
    if (cleanTags.indexOf("courier") !== -1) return "courier";

    return null;
  }

  function truckIcon() {
    return (
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M3 5.5h11v10H3v-10Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path>' +
        '<path d="M14 8.5h3.4l3.1 3.5v3.5H14v-7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path>' +
        '<circle cx="7" cy="17.5" r="1.7" stroke="currentColor" stroke-width="1.8"></circle>' +
        '<circle cx="17.5" cy="17.5" r="1.7" stroke="currentColor" stroke-width="1.8"></circle>' +
      "</svg>"
    );
  }

  function getIndiaTime() {
    try {
      var parts = new Intl.DateTimeFormat("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23"
      }).formatToParts(new Date());

      var hour = 0;
      var minute = 0;

      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === "hour") hour = parseInt(parts[i].value, 10);
        if (parts[i].type === "minute") minute = parseInt(parts[i].value, 10);
      }

      return { hour: hour, minute: minute };
    } catch (e) {
      var now = new Date();
      var utc = now.getTime() + now.getTimezoneOffset() * 60000;
      var ist = new Date(utc + 330 * 60000);

      return {
        hour: ist.getHours(),
        minute: ist.getMinutes()
      };
    }
  }

  function formatHour(hour24) {
    var hour = hour24 % 24;
    var suffix = hour >= 12 ? "PM" : "AM";
    var hour12 = hour % 12 || 12;

    return hour12 + " " + suffix;
  }

  function getExpressValue(hour, minute) {
    /* 12 AM–7:59 AM */
    if (hour < 8) {
      return "Today";
    }

    /* 8 AM–6:59 PM */
    if (hour >= 8 && hour <= 18) {
      var startHour = hour + 2;
      var endHour = startHour + 3;

      return formatHour(startHour) + " – " + formatHour(endHour);
    }

    /* exactly 7:00 PM */
    if (hour === 19 && minute === 0) {
      return "9 PM – 12 AM";
    }

    /* 7:01 PM–7:59 PM */
    if (hour === 19) {
      return "Today";
    }

    /* 8 PM–11:59 PM */
    return "Tomorrow";
  }

   function getDeliveryData(type) {
  var ist = getIndiaTime();

  if (type === "express") {
    return {
      label: "Earliest Delivery: ",
      value: ist.hour >= 20 ? "Tomorrow" : "2-3 Hrs."
    };
  }

  if (type === "courier") {
    return {
      label: "Earliest Dispatch: ",
      value: ist.hour >= 20 ? "Tomorrow" : "Today"
    };
  }

  return null;
}

  function getBadgeHTML(type, extraClass) {
  var data = getDeliveryData(type);
  extraClass = extraClass ? " " + extraClass : "";

  if (!data) return "";

  return (
    '<div class="oy-delivery-badge-wrap' + extraClass + '" data-oy-delivery-type="' + type + '">' +
      '<span class="oy-delivery-badge ' + type + '">' +
        '<span>' +
          '<span class="oy-delivery-badge-prefix">' + data.label + "</span>" +
          '<span class="oy-delivery-badge-time">' + data.value + "</span>" +
        "</span>" +
      "</span>" +
    "</div>"
  );
}

  function fetchProductTags(handle) {
    if (!handle) return Promise.resolve(null);

    var cached = getCachedTags(handle);

    if (cached) return Promise.resolve(cached);
    if (FETCH_PROMISES[handle]) return FETCH_PROMISES[handle];

    FETCH_PROMISES[handle] = fetch(
      "/products/" + encodeURIComponent(handle) + ".js",
      { credentials: "same-origin" }
    )
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        var tags = product && product.tags ? product.tags : [];

        setCachedTags(handle, tags);
        delete FETCH_PROMISES[handle];

        return tags;
      })
      .catch(function () {
        delete FETCH_PROMISES[handle];
        return [];
      });

    return FETCH_PROMISES[handle];
  }

  function getProductHandleFromLink(link) {
    if (!link) return null;

    var href = link.getAttribute("href") || "";
    var match = href.match(/\/products\/([^\/?#]+)/i);

    return match ? decodeURIComponent(match[1]) : null;
  }

  function isInsideExcludedArea(element) {
    return !!(
      element &&
      element.closest(
        "header, nav, footer, .header, .footer, .menu-drawer, .drawer, .cart-drawer, .cart-notification"
      )
    );
  }

  function findCardCandidates() {
    return document.querySelectorAll(
      ".card-wrapper, .card, .product-card, .grid__item, .product-grid-item, .boost-pfs-filter-product-item, .product-item"
    );
  }

  function findProductLink(card) {
    return card ? card.querySelector('a[href*="/products/"]') : null;
  }

  function findPriceElementInCard(card) {
    return card.querySelector(
      ".card-information .price, " +
      ".card__information .price, " +
      ".product-card__price, " +
      ".boost-pfs-filter-product-item-price, " +
      ".product-item__price, " +
      ".price"
    );
  }

  function findProductInfoBlock(card) {
    return card.querySelector(
      ".card-information, " +
      ".card__information, " +
      ".product-card__info, " +
      ".card-information__wrapper, " +
      ".product-item__info"
    );
  }

  function removeCardBadges(card) {
    if (!card) return;

    var badges = card.querySelectorAll(".oy-delivery-badge-wrap:not(.oy-pdp)");

    Array.prototype.forEach.call(badges, function (badge) {
      badge.remove();
    });
  }

  function applyBadgeInCard(card, type, handle) {
    if (!card || isInsideExcludedArea(card)) return;

    removeCardBadges(card);

    if (!type) {
      card.dataset.oyBadgeHandle = handle || "";
      card.dataset.oyBadgeType = "";
      return;
    }

    var priceEl = findPriceElementInCard(card);
    var infoBlock = findProductInfoBlock(card);
    var html = getBadgeHTML(type);

    if (priceEl) {
      priceEl.insertAdjacentHTML("afterend", html);
    } else if (infoBlock) {
      infoBlock.insertAdjacentHTML("beforeend", html);
    }

    card.dataset.oyBadgeHandle = handle || "";
    card.dataset.oyBadgeType = type;
  }

  function enhanceCards() {
    var cards = findCardCandidates();

    Array.prototype.forEach.call(cards, function (card) {
      if (!card || isInsideExcludedArea(card)) return;

      var productLink = findProductLink(card);
      var handle = getProductHandleFromLink(productLink);

      if (!handle) return;

      var existingHandle = card.dataset.oyBadgeHandle || "";
      var badgeExists = !!card.querySelector(".oy-delivery-badge-wrap:not(.oy-pdp)");

      if (existingHandle === handle && badgeExists) {
        return;
      }

      fetchProductTags(handle).then(function (tags) {
        var type = getDeliveryType(tags);
        applyBadgeInCard(card, type, handle);
      });
    });
  }

  function getProductPageHandle() {
    var match = (location.pathname || "").match(/\/products\/([^\/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function findPriceElementInPDP() {
    return document.querySelector(
      ".product__info-container .price, " +
      ".product__info-wrapper .price, " +
      ".product-single__price, " +
      ".price.price--large, " +
      ".product__price, " +
      ".price"
    );
  }

  function removePDPBadges() {
    var badges = document.querySelectorAll(".oy-delivery-badge-wrap.oy-pdp");

    Array.prototype.forEach.call(badges, function (badge) {
      badge.remove();
    });
  }

  function applyBadgeInPDP(type) {
    removePDPBadges();

    if (!type) return;

    var priceElement = findPriceElementInPDP();

    if (!priceElement) return;

    priceElement.insertAdjacentHTML(
      "afterend",
      getBadgeHTML(type, "oy-pdp")
    );
  }

  function enhancePDP() {
    if (location.pathname.indexOf("/products/") === -1) {
      removePDPBadges();
      return;
    }

    var handle = getProductPageHandle();

    if (!handle) return;

    fetchProductTags(handle).then(function (tags) {
      applyBadgeInPDP(getDeliveryType(tags));
    });
  }

  function refreshVisibleBadges() {
    var badges = document.querySelectorAll(
      ".oy-delivery-badge-wrap[data-oy-delivery-type]"
    );

    Array.prototype.forEach.call(badges, function (badge) {
      var type = badge.getAttribute("data-oy-delivery-type");
      var data = getDeliveryData(type);

      if (!data) return;

      var label = badge.querySelector(".oy-delivery-badge-prefix");
      var value = badge.querySelector(".oy-delivery-badge-time");

      if (label) label.textContent = data.label;
      if (value) value.textContent = data.value;
    });
  }

  function init() {
    injectCSSOnce();
    enhanceCards();
    enhancePDP();
    refreshVisibleBadges();

    if (minuteTimer) clearInterval(minuteTimer);

    minuteTimer = setInterval(function () {
      refreshVisibleBadges();
    }, 60000);
  }

  function scheduleEnhancements() {
    clearTimeout(observerTimer);

    observerTimer = setTimeout(function () {
      enhanceCards();
      enhancePDP();
      refreshVisibleBadges();
    }, 150);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleEnhancements();
          break;
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.oyRefreshDeliveryBadges = function () {
    enhanceCards();
    enhancePDP();
    refreshVisibleBadges();
  };
})();
/* ================= OY DELIVERY PROMISE BADGES END ================= */